import React from 'react';
import { LoadingIcon } from '@styled';

const LoadingOverlay = () => (
    <div style={styles.container}>
        <LoadingIcon />
    </div>
);

const styles = {
    container: {
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        left: 0,
        minHeight: '100vh',
        position: 'fixed',
        textAlign: 'center',
        top: 0,
        width: '100%',
        zIndex: 99999,
    },
};

export default LoadingOverlay;
